import { resolveDestination } from "utils/notificationNavRegistry";

/**
 * Returns { path, state } to navigate to for a notification, or null.
 * Routing is driven purely by the structured `notificationType` + `metadata` (see
 * notificationNavRegistry) — never by parsing the message text.
 */
export function getNotificationDestination(item) {
  return resolveDestination(item);
}
